import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import store from 'utils/store'
import NextIcon from 'react-icons/lib/md/navigate-next'
import PrevIcon from 'react-icons/lib/md/navigate-before'
import Keyboard from 'components/shared/keyboard/index'
import {push} from 'react-router-redux'

class NavButton extends React.Component{
  handleClick=()=>{
    this.props.onClick(this.props.direction)
  }
  render(){
    let Icon=this.props.icon
    return (
      <Keyboard keypress={this.props._key} onPress={this.handleClick}>
       <div className={cn(css.navButton, this.props.className)} onClick={this.handleClick}><Icon size={36}/></div>
      </Keyboard>
    )
  }
}

const nextURL=(id)=>{
  let b=window.location.pathname.split('/')
  b.pop()
  b.push(id)
  return b.join('/')
}

export default class Navigation extends React.Component{
  handleClick=(direction)=>{
    let index=this.props.stories.findIndex(s=>s.id===this.props.selected)
    index=index+direction
    if(index>this.props.stories.length-1 | index<0){
      return
    }
    let story=this.props.stories[index]
    store.dispatch(push(nextURL(story.id)))
  }

  render(){
    return (
      <div className={css.navigationBar}>
        <NavButton onClick={this.handleClick} direction={+1} icon={PrevIcon} className={css.right} _key={"left"}/>
          {this.props.children}
        <NavButton onClick={this.handleClick} direction={-1} icon={NextIcon} className={css.left} _key={"right"}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/account_page/story_details/navigation/index.js